import { render } from "./cell_script_log.vue?vue&type=template&id=79117580"
import script from "./cell_script_log.vue?vue&type=script&lang=ts"
export * from "./cell_script_log.vue?vue&type=script&lang=ts"
script.render = render

export default script